<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <p><strong id="pageTitle">MBP-4A Register of Contracts or agreements with any related party under section 188 or in which any director is concerned or interested under sub- section (2) of section 184</strong></p>
      </span>
      <span style="float:right">
        <!-- <a routerLink="/mbp4a/add"> -->
          <button  (click)="add()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/mbp4List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp4List'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
  
            
              <div class="col-lg-3 col-md-3 col-sm-3">
                <label>Name of the interested director</label>
             
                  <select  [(ngModel)]="nameOfTheInterestedDirector" class="form-control" style="padding: 6px;"> 
                        <option value="">Select any one</option>  
                        <option *ngFor="let director of masterDirectorList" value="{{director.FirstName + ' '+ director.LastName}}">  
                            {{director.FirstName + " "+ director.LastName}}
                        </option> 
                  </select>
               </div>
              
  
              <div class="form-group col-lg-3 col-md-3 col-sm-3">
                <label>Transaction Type</label>
                <select class="form-control" style="padding:6px;" [(ngModel)]="transactionType"
                  (change)="transactionTypeChange()">
                  <option value="" [selected]="true"> Select any one </option>
                  <option value="contract">Contract</option>
                  <option value="arrangement">Arrangement</option>
                </select>
              </div>
  
  
              <!-- <div class="form-group col-lg-4 col-md-4 col-sm-4" *ngIf="transactionType == 'contract'">
                <label>Date of Contract</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfContract" class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                    name="dateOfContract" ngbDatepicker #cesDate="ngbDatepicker" (click)="cesDate.toggle()"
                    [(ngModel)]="dateOfContract">
                  <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
  
  
              <div class="col-md-4" *ngIf="transactionType == 'contract'">
                <label>Date of Contract</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfContract" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfContract" ngbDatepicker
                    #cesDate="ngbDatepicker" (click)="cesDate.toggle();b.close()" [(ngModel)]="dateOfContract">
                  <button class="input-group-addon" (click)="cesDate.toggle();b.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                  &nbsp;&nbsp; To:&nbsp;
                  <input id="dateOfContractTo" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfContractTo" ngbDatepicker
                  #b="ngbDatepicker" (click)="b.toggle();cesDate.close()" [(ngModel)]="dateOfContractTo">
                <button class="input-group-addon" (click)="b.toggle();;cesDate.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
  <!-- 
              <div class="form-group col-lg-4 col-md-4 col-sm-4" *ngIf="transactionType == 'arrangement'">
                <label>Date of arrangement</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfArrangement" class="form-control" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" name="dateOfArrangement" ngbDatepicker #cesDate="ngbDatepicker"
                    (click)="cesDate.toggle()" [(ngModel)]="dateOfArrangement">
                  <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
  
  
              <div class="col-md-4" *ngIf="transactionType == 'arrangement'">
                <label>Date of Arrangement</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfArrangement" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfArrangement" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfArrangement">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                  &nbsp;&nbsp; To:&nbsp;
                  <input id="dateOfArrangementTo" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfArrangementTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfArrangementTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
              <div class="form-group col-lg-2 col-md-2 col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfMbp" [dtTrigger]="dtTriggerMbp"
                class="table table-hover compact cell-border nowrap stripe" id="directormasterMbp4Table"
                style="cursor: pointer;">
                <thead>
                  <tr>
  
  
                    <th>Date of Contract</th>
                    <th style="display: none">Date of Contract</th>
                    <th>Date of Arrangement</th>
                    <th style="display: none">Date of Arrangement</th>
                    <th>Name of the party with <br>which contract is entered into</th>
                    <th>Name of the interested <br>director</th>
                    <th class="actionclass">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                    <td>
                      <span style="display: none">{{director.dateOfContract | date : "yMMdd"}}</span>
                      {{director.dateOfContract | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{director.dateOfContract | date : "dd-MM-y"}}
                    </td>
                    <td>
                      <span style="display: none">{{director.dateOfArrangement | date : "yMMdd"}}</span>
                      {{director.dateOfArrangement | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{director.dateOfArrangement | date : "dd-MM-y"}}
                    </td>
                    <td tabindex="1">{{director.nameOfTheParty}}</td>
                    <td tabindex="1">{{director.nameOfTheInterestedDirector}}</td>
  
  
  
  
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" (click)="editMbpDetails(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mbp4List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp4List'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mbp4List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp4List'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- </div> -->
    <!-- </div> -->
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete MBP-4(A) details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteMbpData()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>